import { FC, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

type Props = {
  enabled?: boolean;
};

const FormAutosubmit: FC<Props> = ({ enabled = false }) => {
  const { isValid, submitForm } = useFormikContext();
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (enabled && isValid && !submitted) {
      submitForm();
      setSubmitted(true);
    }
  }, [enabled, isValid, submitForm, submitted]);

  return <></>;
};

export default FormAutosubmit;
